import { Pipe, PipeTransform } from '@angular/core';
import { IngredientChoiceGroup } from 'ngx-web-api';

@Pipe({
  name: 'groupIndex',
})
export class GroupIndexPipe implements PipeTransform {
  transform(choiceGroup: IngredientChoiceGroup, groups: IngredientChoiceGroup[]): number {
    if (!groups) {
      return -1;
    }
    return choiceGroup ? groups.findIndex(group => group.name === choiceGroup.name) : -1;
  }
}
